import { createSvgIcon } from "@material-ui/core/utils";
import React from "react";

export const ArrowRightIcon = createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M13.8446 6.2943C14.237 5.9019 14.8732 5.9019 15.2656 6.2943L20.6464 11.6752C20.8417 11.8704 20.8417 12.187 20.6464 12.3823L15.2656 17.7632C14.8732 18.1556 14.237 18.1556 13.8446 17.7632C13.4522 17.3708 13.4522 16.7346 13.8446 16.3422L17.1532 13.0335H4.00479C3.44986 13.0335 3 12.5837 3 12.0287C3 11.4738 3.44986 11.0239 4.00479 11.0239H17.1532L13.8446 7.71528C13.4522 7.32289 13.4522 6.68669 13.8446 6.2943Z"
    fill="currentColor"
  />,
  "ArrowRightIcon"
);
